import PropTypes from 'prop-types';

export const promotionalBundleProps = {
  id: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  tagline: PropTypes.string.isRequired,
  description: PropTypes.string,
  clickthroughPath: PropTypes.string.isRequired,
  bundlePriceText: PropTypes.string.isRequired,
  savingsText: PropTypes.string.isRequired,
  audiobooks: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      coverUrl: PropTypes.string.isRequired,
      displayAuthors: PropTypes.string.isRequired,
      displayTitle: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export const promotionalBundle = PropTypes.shape(promotionalBundleProps);
